import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {PartnerService} from '../../../shared/services/partner.service';

@Component({
    selector: 'app-add-partner',
    templateUrl: './add-partner.component.html',
    styleUrls: ['./add-partner.component.scss']
})
export class AddPartnerComponent implements OnChanges {
    addPartnerForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private partnerService: PartnerService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-partner').toggleOpen();
    }

    refresh() {
        this.addPartnerForm = this.fb.group({
            'name': ['', Validators.required],
            'website': [''],
            'short_description': ['']
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addPartnerForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'website': (this.data && this.data['website']) ? this.data['website'] : '',
            'short_description': (this.data && this.data['short_description']) ? this.data['short_description'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addPartnerForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addPartnerForm.value && this.addPartnerForm.value.name) ? this.addPartnerForm.value.name : '',
                'website': (this.addPartnerForm.value && this.addPartnerForm.value.website) ? this.addPartnerForm.value.website : '',
                'short_description': (this.addPartnerForm.value && this.addPartnerForm.value.short_description) ? this.addPartnerForm.value.short_description : '',
            };
            this.submitting = true;
            this.partnerService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addPartnerForm.reset();
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addPartnerForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addPartnerForm.value && this.addPartnerForm.value.name) ? this.addPartnerForm.value.name : '',
                'website': (this.addPartnerForm.value && this.addPartnerForm.value.website) ? this.addPartnerForm.value.website : '',
                'short_description': (this.addPartnerForm.value && this.addPartnerForm.value.short_description) ? this.addPartnerForm.value.short_description : '',
            };
            this.submitting = true;
            this.partnerService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }
}
